import { render, staticRenderFns } from "./Descricao.vue?vue&type=template&id=ba8c4798&"
import script from "./Descricao.vue?vue&type=script&lang=js&"
export * from "./Descricao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports